exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".IBv79{padding:0}@media (min-width:768px){.IBv79{padding:108px 0 0}}._33nsK{margin:50px auto;padding:0 0 40px;max-width:1000px;display:-webkit-box;display:-ms-flexbox;display:flex}._2AKYw{padding-left:25px;text-align:justify}@media (max-width:768px){._33nsK,.IBv79{width:100%}._33nsK{display:block;margin:2px auto;padding:0}._2AKYw{margin-top:25px;padding-right:25px}}._2AKYw h1{color:#111;font-size:26px;font-size:1.625rem}._2AKYw h1,._2AKYw h2{font-weight:400;margin:0 0 19.2px;margin:0 0 1.2rem}._2AKYw h2{color:#333;font-size:20px;font-size:1.25rem}._2AKYw ol+h2,._2AKYw p+h2{margin-top:57.6px;margin-top:3.6rem}._2AKYw ol>li,._2AKYw p{color:#666;font-size:15.2px;font-size:.95rem;font-weight:300;line-height:28.8px;line-height:1.8rem;margin-bottom:28.8px;margin-bottom:1.8rem}._2AKYw ol{padding-left:30px}._2AKYw ol>li{padding-left:10px}._2AKYw img{margin-bottom:25px;width:100%}@media (max-width:768px){._2l1zB{margin-bottom:25px}}._2l1zB{background-color:#f7f7f7;border:1px solid #e0e0e0;color:#666;font-weight:300;font-size:15px;font-size:.9375rem;display:block;overflow:auto;padding:2px}", ""]);

// exports
exports.locals = {
	"root": "IBv79",
	"container": "_33nsK",
	"contents": "_2AKYw",
	"gallery": "_2l1zB"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/routes/about-us/AboutUs.css
// module id = 927
// module chunks = 2